import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	noResultsWithFilters: {
		id: 'software-cycle-time-breakdown-report.historical-cycle-time.no-matches.no-results-with-filters',
		defaultMessage: 'No matching data found',
		description: 'Text indicating that there are no deployments to display in the table',
	},
	noResultsHeading: {
		id: 'software-cycle-time-breakdown-report.historical-cycle-time.no-matches.no-results-heading',
		defaultMessage: "Get the last 12 weeks' data from your deployment tools",
		description: 'Text indicating that there are no deployments to display in the table',
	},
	notEnoughDataMessage: {
		id: 'software-cycle-time-breakdown-report.historical-cycle-time.no-matches.not-enough-data-message',
		defaultMessage:
			'To view this report, you need deployment events from your CI/CD tool and commit events from your source code management tool.',
		description:
			'explains to user that the project does not have the required deployment and commit data to generate the report',
	},
	explanationActiveFilter: {
		id: 'software-cycle-time-breakdown-report.historical-cycle-time.no-matches.explanation-active-filter',
		defaultMessage: 'Reset your search criteria by changing your filters',
		description: 'Text explaining why there are no deployments to display in the table',
	},
	learnMore: {
		id: 'software-cycle-time-breakdown-report.historical-cycle-time.no-matches.learn-more',
		defaultMessage: 'Learn more',
		description: 'A link to a url explaining how to connect CI/CD',
	},
	clearFilter: {
		id: 'software-cycle-time-breakdown-report.historical-cycle-time.no-matches.clear-filter',
		defaultMessage: 'Clear filter',
		description: 'Clear filter button caption',
	},
});
